import React, { memo } from "react";
import styled, { css } from "styled-components";
import { secondaryBackground } from "../../../helpers/background";
import { defaultColor, dividerColor } from "../../../helpers/color";
import { useRect } from "./state/rect";
import { useSize } from "./state/size";
import { useScope } from "./state/scope";
const Root = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-d8igyo-0"
})(["", " position:absolute;top:0;left:25%;width:50%;height:6px;border-bottom:2px solid ", ";"], secondaryBackground, dividerColor));
const Pixels = /*#__PURE__*/memo(styled.div.attrs(props => ({
  style: {
    backgroundPosition: `-${props.pixels * props.offset}px 0`,
    backgroundImage: `repeating-linear-gradient(
			90deg,
			${(props.strong ? defaultColor : dividerColor)(props)},
			${(props.strong ? defaultColor : dividerColor)(props)} 1px,
			transparent 1px,
			transparent ${props.pixels - 1}px,
			${(props.strong ? defaultColor : dividerColor)(props)} ${props.pixels - 1}px,
			${(props.strong ? defaultColor : dividerColor)(props)} ${props.pixels}px
		)`
  }
})).withConfig({
  displayName: "Pixels",
  componentId: "sc-d8igyo-1"
})(["position:absolute;top:0;bottom:0;left:0;width:100%;"]));
const Ruler = /*#__PURE__*/memo(() => {
  const rect = useRect();
  const size = useSize();
  const scope = useScope();
  const pixels = rect.width / (size / 1000);
  return /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(Pixels, {
    pixels: pixels,
    offset: scope.offset % 1000 / 1000
  }), /*#__PURE__*/React.createElement(Pixels, {
    strong: true,
    pixels: pixels * 5,
    offset: scope.offset % 5000 / 5000
  }));
});
export default Ruler;
//# sourceMappingURL=Ruler.js.map